import React from 'react'

import { Form, Col } from '_zari/core'

import { SeInventarios } from 'constants/index'

const SalidaEntradaTipoFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO' htmlFor='select-se' md={4} alignRightAt='md' />
      <Col md={8}>
        <Form.Select id='select-se' name='select-se' value={value} onChange={onChange}>
          <option value=''>Seleccionar</option>
          {SeInventarios.__array.map((val, key) => (
            <option key={key} value={val.id}>
              {val.nombre}
            </option>
          ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(SalidaEntradaTipoFormGroup)
